import application_settings from '../applicationSettings';
import Event from './Event';
import LocalStorage from '../local_data';

class GetFilters extends Event {
    eventName = 'oms_getFilters';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get filters
     * 
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        // request data
        data.endPoint = application_settings.endPoints.getFilters;

        this.sendRequest(data, function (response) {
            if (response) {
                //add data to storage
                let filters = new LocalStorage.ClientFilters(clientId);
                filters.setData(response);

                //format response data
                let data = thisObj.formatResponseData(response);

                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
            }
        });

    }
}

export default GetFilters;